import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Button } from 'semantic-ui-react';

import '../css/StudentAccessCode.less';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';
import PopupService from '../services/PopupService';
import UtilityService from '../services/UtilityService';

export default
@inject('classroomManager')
@observer
class StudentAccessCode extends Component {
  constructor(props) {
    super(props);
    this.InfoIcon = SatCoreComponent('InfoIcon');
  }

  componentDidMount() {}

  handleClickRefreshCode = (e) => {
    const { classroomManager, classId } = this.props;
    e.preventDefault();
    classroomManager.refreshStudentAccessCode(classId);
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onClick?.();
  }

  render() {
    const { classroomManager, classId, onClick, t, useWhiteInfoIcon } = this.props;

    const { InfoIcon } = this;

    let code = '';
    if (classId && classId !== '') {
      code = classroomManager.getStudentAccessCode(classId);
    }

    const tooltipAccessCode = t('tooltipAccessCode', '') || t('tooltipStudentAccessCode', '');
    const parsedTooltipAccessCode = tooltipAccessCode
      ? UtilityService.reactHtmlParserWrapper(tooltipAccessCode).parsed
      : '';
    const refreshStudentAccessCodeInfo = t('refreshStudentAccessCodeInfo', '');

    return (
      <div className='studentAccessCode' onClick={onClick}>
        <div className='accessCodeHeader'>
          {t('studentAccessCode', 'Student Access Code')}
          {!!tooltipAccessCode && (
            <InfoIcon className='InfoIcon-tooltipStudentAccessCode InfoIcon-tooltip-default'
              popupOptions={{ content: parsedTooltipAccessCode, on: 'hover' }}
              useWhiteInfoIcon={useWhiteInfoIcon} />
          )}
        </div>
        <div className='accessCode'>
          <div className='accessCodeLabel'>{code}</div>
          <div className='accessCodeRefresh'>
            {PopupService.renderPopup({
              content: refreshStudentAccessCodeInfo,
              disabled: !refreshStudentAccessCodeInfo,
              trigger: (
                <Button basic onClick={this.handleClickRefreshCode}
                  size='mini' type='button'>
                  {t('refresh', 'Refresh')}
                </Button>
              ),
              wide: false
            })}
          </div>
        </div>
      </div>
    );
  }
}

SatCoreRegister('StudentAccessCode', StudentAccessCode);
